/* global FavoritesEnabled */
/* eslint-disable jsx-a11y/no-static-element-interactions, react/no-array-index-key */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import Icon from 'components/Icon';
import Badge from 'components/Badge';
import Tile from 'components/TileLegacy';
import Dropdown from 'components/Dropdown';
import Favorite, {
  FAVORITE_TYPE_ICON,
  FAVORITE_TYPE_BUTTON,
  FAVORITE_PLUS_CIRCLE,
} from 'components/Favorite';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import { LIVE_EPG_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import {
  Events,
  getTealiumLiveEvents,
  handleAnalytics,
  handleTealiumButtonAction,
  PageNames,
  SegmentSources,
  setSegmentRestartedPlaybackGlobal,
  tealiumEventPageTypes,
  TrackEvents as GeneralTrackEvents,
} from '@foxcorp/delta-web-analytics';
import { scheduleItemVideoProcessor, requiresAuthElement } from 'helpers/VideoProcessorHelper';
import {
  getShowType,
  truncateDesc,
  isSportsContent,
  isSportsVideoLive,
} from 'helpers/ContentHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import CountdownText from 'components/CountdownText';
import {
  FORMAT_TIME,
  now,
  isBefore,
  isAfter,
  differenceInMinutes,
  format,
  stringToDate,
  msToDate,
} from 'helpers/DateTimeHelper';
import { OVERLAY_LIVE_CTA_OVERFLOW } from 'helpers/FilterHelper';
import {
  getVideoData,
  getMobileVideoMetadata,
  getVideoTimeData,
  calculateDurationWidth,
  TYPE_SHOW,
  isReturningVistor,
  isGapFiller,
} from 'screens/Live/LiveHelpers';
import { restoreLiveGridState } from 'screens/Live/LiveActions';
import dropdownTheme from 'screens/Live/styles/Dropdown.css';
import favoriteTheme from 'screens/Live/styles/Favorite.css';
import tileTheme from './ScheduleItemTile.css';
import Style from './ScheduleItem.module.scss';

const trackingPageType = _.get(tealiumEventPageTypes, PageNames.LIVE_SCHEDULE);
const TYPE_CURRENT = 'current';
const TYPE_FUTURE = 'future';
const TYPE_DUMMY = 'dummy';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    enableTruncateDesc: false,
    gridTotalHours: 3,
    canScrollGrid: true,
  },
  [SITE_PLATFORM_WEB]: {
    enableTruncateDesc: false,
    gridTotalHours: 2,
    canScrollGrid: true,
  },
  [SITE_PLATFORM_TABLET]: {
    enableTruncateDesc: false,
    canScrollGrid: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    enableTruncateDesc: false,
    canScrollGrid: false,
  },
};

class ScheduleItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openItemId: null,
    };
    this.toggleOverflowDropdown = this.toggleOverflowDropdown.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { openRow, rowIdx, prevOpenRow, prevRowIdx, location, restoreLiveGridState } = this.props;
    const { openRow: nextOpenRow } = nextProps;
    const { openItemId } = this.state;
    if (openRow === rowIdx && openRow !== nextOpenRow) {
      this.setState({ openItemId: null });
    }
    if (prevOpenRow && openItemId === null && prevRowIdx === rowIdx) {
      if (isReturningVistor(location)) {
        this.toggleItemId(prevOpenRow, prevRowIdx);
      }
      restoreLiveGridState();
    }
  }

  shouldComponentUpdate(nextProps) {
    const { openRow, rowIdx, epgGridPage, dropdownDateClosed } = this.props;
    const { openRow: nextOpenRow, epgGridPage: nextEpgGridPage } = nextProps;

    if (
      nextOpenRow !== rowIdx &&
      openRow !== rowIdx &&
      epgGridPage === nextEpgGridPage &&
      !dropdownDateClosed
    )
      return false;
    return true;
  }

  componentWillUnmount() {
    const { restoreLiveGridState, rowIdx } = this.props;
    const { openItemId } = this.state;
    if (openItemId) {
      restoreLiveGridState(openItemId, rowIdx);
    }
  }

  getDummyTitle(startDate) {
    const { displayPrimeTimeMessage, primeTimeMessage, network, loadingGrid } = this.props;
    const {
      global_loading: textLoading,
      programNotAvailable_text: textProgramNotAvailable,
      epg_prePrimetimeText: textPrePrimeTime,
    } = window.Language;
    const dummyVideo = {
      network,
      startDate,
    };
    const showPrimeTimeMessage = displayPrimeTimeMessage(dummyVideo);
    if (loadingGrid) return textLoading;
    if (!showPrimeTimeMessage) return textProgramNotAvailable;
    return primeTimeMessage || textPrePrimeTime;
  }

  getVideoById(id) {
    const { item } = this.props;
    const member = _.get(item, 'items.member', null);
    return member.find(x => x['@id'] === id) || null;
  }

  addDummyBlocks() {
    const {
      breakpoint,
      breakpointIsMobile,
      isOverFlow,
      item,
      lateProgramIdx,
      overFlowProgramIdx,
      selectedDate,
    } = this.props;
    const { gridTotalHours, canScrollGrid } = BREAKPOINTS[breakpoint];
    const member = _.get(item, 'items.member', null);
    if (!member) return null;

    const selectedDateCalc = selectedDate ? stringToDate(selectedDate) : now();
    const blocks = [];
    let currentShown = false;
    member.map((vid, idx) => {
      let video = vid;
      if (!isOverFlow && overFlowProgramIdx !== -1 && idx > lateProgramIdx && !breakpointIsMobile) {
        const lateProgramEndDateString = member[lateProgramIdx].endDate;
        const videoStartDate = stringToDate(video.startDate);
        const videoEndDate = stringToDate(video.endDate);
        const lateProgramEndDate = stringToDate(lateProgramEndDateString);

        const isBeforeLateProgram = isBefore(videoStartDate, lateProgramEndDate);
        const isAfterLateProgram = isAfter(videoEndDate, lateProgramEndDate);

        if (!isAfterLateProgram) return null;
        if (isBeforeLateProgram) {
          video = _.cloneDeep(video);
          video.startDate = lateProgramEndDateString;
        }
      }
      const videoTimeData = getVideoTimeData({
        video,
        current: selectedDate,
        gridTotalHours,
        canScrollGrid,
      });
      const { id, title, subtitle, badge } = getVideoData(video);
      const {
        starts,
        ends,
        isCurrent,
        startsInFuture,
        shouldBeVisible,
        withinSameDay,
        startsWithGrid,
      } = videoTimeData;
      const videoIsGapFiller = isGapFiller(video);
      let width = null;

      if (!isCurrent && !startsInFuture) {
        return null;
      }
      // if starts in future, calculate the width using duration
      if (startsInFuture && !isCurrent) {
        width = this.calculateBlockWidth(TYPE_FUTURE, videoTimeData);
        // if its current, calculate the timeLeft until it ends.
      } else if (isCurrent) {
        width = this.calculateBlockWidth(TYPE_CURRENT, videoTimeData);
        currentShown = true;
      }

      // add the dummy block if is there a gap
      if (startsInFuture && !currentShown) {
        const ends = format(stringToDate(video.startDate), FORMAT_TIME);
        blocks.push({
          id: `dummy-${id}`,
          itemClass: classNames(Style.scheduleItem, Style.current),
          width: this.calculateBlockWidth(TYPE_DUMMY, videoTimeData),
          title: isOverFlow ? '' : this.getDummyTitle(selectedDateCalc),
          subtitle: '',
          starts: '',
          ends,
          isDummy: true,
          shouldBeVisible: true,
          badge,
        });
        currentShown = true;
      }
      if (shouldBeVisible || (breakpointIsMobile && withinSameDay)) {
        blocks.push({
          id,
          isCurrent,
          width,
          title,
          subtitle,
          badge,
          starts,
          ends,
          isDummy: videoIsGapFiller,
          shouldBeVisible,
          startsWithGrid,
        });
      }
      return null;
    });

    if (blocks.length === 0) {
      blocks.push({
        id: 'dummy-1',
        itemClass: classNames(Style.scheduleItem, Style.current),
        width: calculateDurationWidth(180),
        title: this.getDummyTitle(selectedDateCalc),
        subtitle: '',
        starts: '',
        ends: '',
        isDummy: true,
        shouldBeVisible: true,
        badge: null,
      });
    } else {
      // add a dummy at the end just to fill the gaps if any.
      blocks.push({
        id: 'dummy-end',
        itemClass: classNames(Style.scheduleItem, Style.current),
        width: calculateDurationWidth(180),
        title: isOverFlow ? '' : this.getDummyTitle(selectedDateCalc),
        subtitle: '',
        starts: '',
        ends: '',
        isDummy: true,
        shouldBeVisible: true,
        badge: null,
      });
    }
    return blocks;
  }

  calculateBlockWidth(type, video) {
    const { startingTs } = this.props;
    const gridStarts = msToDate(startingTs * 1000);
    let timeLeft;
    let width;

    const { duration, startDate, endDate } = video;
    const starts = stringToDate(startDate);
    const ends = stringToDate(endDate);

    switch (type) {
      case TYPE_FUTURE:
        width = calculateDurationWidth(duration);
        break;
      case TYPE_CURRENT:
        timeLeft = differenceInMinutes(ends, gridStarts);
        width = calculateDurationWidth(timeLeft);
        break;
      case TYPE_DUMMY:
        timeLeft = differenceInMinutes(starts, gridStarts);
        width = calculateDurationWidth(timeLeft);
        break;
      default:
        width = 0;
        break;
    }
    return width;
  }

  toggleItemId(id, newRowIdx) {
    const { rowIdx, scheduleItemDetailsCB, resetStillWatchingTimeout } = this.props;
    const { openItemId } = this.state;
    let newopenItemId = id;
    const row = newRowIdx || rowIdx;
    if (typeof scheduleItemDetailsCB === 'function') {
      if (newopenItemId === openItemId) {
        scheduleItemDetailsCB(row, 'close');
        newopenItemId = null;
      } else {
        scheduleItemDetailsCB(row, 'open');
        const video = this.getVideoById(newopenItemId);
        if (video !== null) {
          const { subtitle, title } = getVideoData(video);
          handleAnalytics({
            event: Events.LIVE_TV_EPG_CELL_TAPPED,
            payload: {
              page_action_type: 'open cell detail',
              page_item_title: title,
              page_item_subtitle: subtitle,
            },
          });
        }
      }
    }
    this.setState({ openItemId: newopenItemId });
    resetStillWatchingTimeout();
  }

  toggleOverflowDropdown() {
    const { resetStillWatchingTimeout, setOverlay } = this.props;
    setOverlay(OVERLAY_LIVE_CTA_OVERFLOW);
    resetStillWatchingTimeout();
  }

  renderDetails() {
    const {
      account,
      breakpoint,
      breakpointIsMobile,
      callSign,
      isAuthenticated,
      item,
      overFlowProgramIdx,
      resetStillWatchingTimeout,
      rowIdx,
      saveLiveRestart,
      switchChannelCB,
    } = this.props;
    const { enableTruncateDesc, canScrollGrid } = BREAKPOINTS[breakpoint];
    const { openItemId } = this.state;
    if (openItemId === null) return <div className={Style.detailContainer} />;

    const {
      global_moreSeriesDeeplinkButton: labelMoreEpisodes,
      global_watchLiveButton: labelWatchLive,
      global_watchButton: labelWatch,
      global_restartButton: labelRestart,
    } = window.Language;
    const video = this.getVideoById(openItemId);
    if (video === null) return null;

    const {
      description,
      fullEpisodeCount,
      metadata: metadataSource,
      moreInfoUrl,
      requiresAuthLive,
      shouldRenderVODCta,
      shouldRenderLiveCta,
      subtitle,
      subtitleName,
      title,
      videoType,
      watchUrl,
    } = getVideoData(video);
    const restartData = video;
    const metadata = breakpointIsMobile ? getMobileVideoMetadata(video) : metadataSource;
    const videoIsSportsContent = isSportsContent(video);
    const { isCurrent, secUntilStart } = getVideoTimeData({ video, canScrollGrid });

    const isAuthZ = !requiresAuthLive;
    const lockIcon = requiresAuthElement({
      requiresAuth: requiresAuthLive,
      lockClass: Style.lock,
      isAuthenticated,
      viewBox: '0 4 24 20',
    });
    const actionButtons = [];
    const ctaDetails = [];
    const actionButtonsClasses = [Style.actionButtons];
    const handleWatchLive = () => {
      const {
        [GeneralTrackEvents.SCHEDULE_WATCH_LIVE]: tealiumScheduleWatchLive,
      } = getTealiumLiveEvents();
      handleAnalytics({
        event: Events.LIVE_TV_BUTTON_ACTION,
        payload: {
          page_item_title: title,
          page_item_subtitle: subtitle,
          page_action_type: 'watch',
        },
      });
      tealiumScheduleWatchLive({ network: callSign });
      handleTealiumButtonAction({ text: labelWatchLive, title, subtitle: subtitleName, account });
      resetStillWatchingTimeout();
      this.toggleItemId(openItemId);
    };

    let watchLiveButton = null;
    const videoIndex = _.findIndex(item.items.member, video);
    const newRowIdx =
      videoIndex === overFlowProgramIdx && breakpointIsMobile ? `${rowIdx}-overFlow` : rowIdx;
    const buttonText =
      videoIsSportsContent && !isSportsVideoLive(video) ? labelWatch : labelWatchLive;

    if (shouldRenderLiveCta) {
      let liveBtnClasses = Style.actionButton;

      if (!isAuthZ) {
        liveBtnClasses = classNames(
          liveBtnClasses,
          isAuthenticated ? Style.noAuthZActionButton : Style.actionButtonLocked,
        );
      }

      watchLiveButton = (
        <Link
          key={`watch-live-${openItemId}`}
          className={liveBtnClasses}
          onClick={() => {
            handleWatchLive();
            switchChannelCB(newRowIdx);
          }}
        >
          {lockIcon} {buttonText}
        </Link>
      );

      if (videoIsSportsContent) {
        actionButtons.push(watchLiveButton);
        ctaDetails.push({
          name: buttonText,
          onClick: () => {
            handleWatchLive();
            switchChannelCB(newRowIdx);
          },
        });
      }
    }

    if (shouldRenderVODCta) {
      const vodText = isCurrent ? labelRestart : labelWatch;
      let restartBtnClasses = Style.actionButton;
      if (!isAuthZ) {
        restartBtnClasses = classNames(
          restartBtnClasses,
          isAuthenticated ? Style.noAuthZActionButton : Style.actionButtonLocked,
        );
      }
      ctaDetails.push({
        name: vodText,
        onClick: () => {
          const { router } = this.props;
          const {
            [GeneralTrackEvents.SCHEDULE_RESTART]: tealiumScheduleRestart,
          } = getTealiumLiveEvents();

          saveLiveRestart(restartData);
          handleTealiumButtonAction({ text: vodText, title, subtitle: subtitleName, account });
          handleAnalytics({
            event: Events.LIVE_TV_BUTTON_ACTION,
            payload: {
              page_item_title: title,
              page_item_subtitle: subtitle,
              page_action_type: 'restart',
            },
          });
          tealiumScheduleRestart({ network: callSign });
          if (isCurrent) setSegmentRestartedPlaybackGlobal(true);
          resetStillWatchingTimeout();
          router.push(watchUrl);
        },
      });
      actionButtons.push(
        <Link
          data-test="epg-detail-restart-cta"
          key={`restart-${openItemId}`}
          className={restartBtnClasses}
          to={watchUrl}
          onClick={() => {
            const {
              [GeneralTrackEvents.SCHEDULE_RESTART]: tealiumScheduleRestart,
            } = getTealiumLiveEvents();

            saveLiveRestart(restartData);
            handleTealiumButtonAction({ text: vodText, title, subtitle: subtitleName, account });
            handleAnalytics({
              event: Events.LIVE_TV_BUTTON_ACTION,
              payload: {
                page_item_title: title,
                page_item_subtitle: subtitle,
                page_action_type: 'restart',
              },
            });
            tealiumScheduleRestart({ network: callSign });
            if (isCurrent) setSegmentRestartedPlaybackGlobal(true);
            resetStillWatchingTimeout();
          }}
        >
          {lockIcon} {vodText}
        </Link>,
      );
    }

    if (shouldRenderLiveCta && !videoIsSportsContent) {
      actionButtons.push(watchLiveButton);
      ctaDetails.push({
        name: buttonText,
        onClick: () => {
          handleWatchLive();
          switchChannelCB(newRowIdx);
        },
      });
    }

    const showCountdownSeconds = _.get(window.ExternalConfig, 'countDownTimerInSeconds', 5 * 60);
    const shouldShowTimer = !isCurrent && secUntilStart && secUntilStart < showCountdownSeconds;
    if (shouldShowTimer) {
      let countdownBtnClasses = Style.actionButton;
      if (!isAuthZ) {
        countdownBtnClasses = classNames(
          countdownBtnClasses,
          isAuthenticated ? Style.noAuthZActionButton : Style.actionButtonLocked,
        );
      }
      actionButtonsClasses.push(Style.buttonGutter);
      const buttonKey = `up-next-${openItemId}`;
      actionButtons.push(
        <Link
          key={buttonKey}
          className={countdownBtnClasses}
          onClick={() => {
            handleWatchLive();
            switchChannelCB(rowIdx);
          }}
        >
          <div className={Style.actionButtonText}>
            {lockIcon}
            Tune In Now
            <span className={Style.secondaryText}>
              <CountdownText prefix="Starts in " duration={secUntilStart} />
            </span>
          </div>
        </Link>,
      );
      ctaDetails.push({
        name: 'Tune In Now',
        onClick: () => {
          handleWatchLive();
          switchChannelCB(rowIdx);
        },
      });
    }

    if (fullEpisodeCount) {
      actionButtons.push(
        <Link
          onClick={() => {
            handleAnalytics({
              event: Events.LIVE_TV_BUTTON_ACTION,
              payload: {
                page_item_title: title,
                page_item_subtitle: subtitle,
                page_action_type: 'more episodes',
              },
            });
          }}
          key={`more-episodes-${openItemId}`}
          className={Style.actionButton}
          to={moreInfoUrl}
        >
          {labelMoreEpisodes}
        </Link>,
      );
      ctaDetails.push({
        name: labelMoreEpisodes,
        onClick: () => {
          const { router } = this.props;
          handleAnalytics({
            event: Events.LIVE_TV_BUTTON_ACTION,
            payloadd: {
              page_item_title: title,
              page_item_subtitle: subtitle,
              page_action_type: 'more episodes',
            },
          });
          router.push(moreInfoUrl);
        },
      });
    }

    const mobileActionButtons =
      actionButtons.length > 2 ? actionButtons.slice(0, 2) : actionButtons;

    const tileProps = scheduleItemVideoProcessor({ item: video });
    let descriptionElement = null;
    let rightElement = null;
    let actionButtonsElement = null;
    if (!breakpointIsMobile) {
      descriptionElement = (
        <div className={Style.detailDescription}>
          {truncateDesc(description, enableTruncateDesc)}
        </div>
      );
      rightElement = (
        <div className={Style.detailContainerRight}>
          <Tile
            itemIndex={0}
            {...tileProps}
            theme={tileTheme}
            renderImage={image =>
              renderImage({
                breakpoint,
                imageType: LIVE_EPG_THUMBNAIL_IMAGE,
                ...image,
              })
            }
          />
        </div>
      );
    }
    if (actionButtons && actionButtons.length > 0) {
      actionButtonsElement = (
        <div
          className={classNames(actionButtonsClasses, Style.actionButtons)}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {breakpointIsMobile ? mobileActionButtons : actionButtons}
          {!breakpointIsMobile && this.renderFavorite(FAVORITE_TYPE_BUTTON)}
          {breakpointIsMobile && this.renderOverflowDropdown(ctaDetails)}
        </div>
      );
    } else {
      actionButtonsElement = (
        <div
          className={classNames(actionButtonsClasses, Style.actionButtons)}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {!breakpointIsMobile && this.renderFavorite(FAVORITE_TYPE_BUTTON)}
        </div>
      );
    }
    const shouldRenderSubtitle =
      (!videoIsSportsContent && videoType === TYPE_SHOW) || video.sportTag;

    return (
      <div className={Style.detailContainer}>
        <div className={Style.detailContainerLeft}>
          <h2 className={Style.detailTitle}>{title}</h2>
          {breakpointIsMobile && this.renderFavorite(FAVORITE_TYPE_ICON)}
          {shouldRenderSubtitle && <div className={Style.detailSubtitle}>{subtitle}</div>}
          {descriptionElement}
          <div className={Style.detailInfo}>{metadata}</div>
          {actionButtonsElement}
        </div>
        {rightElement}
      </div>
    );
  }

  renderFavorite(favoriteType) {
    const { network, favoritesManager } = this.props;
    const { openItemId } = this.state;
    const video = this.getVideoById(openItemId);
    const {
      categoryType,
      showCode: showID,
      seriesName,
      favoritableItems,
      seriesType,
      videoType,
    } = video;
    const isPersonality = categoryType && categoryType === 'personality';
    const showType = getShowType({ seriesType, videoType });
    const { title, subtitle } = getVideoData(video);
    if (!FavoritesEnabled) return null;
    const recommendationId = _.get(video, 'trackingData.properties.recommendationId', null);
    const favoriteData = {
      actionLocation: 'live epg',
      showID,
      networkId: network,
      seriesName,
      showType,
      favoriteType: isPersonality ? 'personality' : showType,
      location: trackingPageType,
      source: SegmentSources.DETAIL,
      recommendationId,
      favoritableItems,
    };
    return (
      <div
        className={favoriteTheme.wrapper}
        onClick={e => {
          handleAnalytics({
            event: Events.LIVE_TV_BUTTON_ACTION,
            payload: {
              page_item_title: title,
              page_item_subtitle: subtitle,
              page_action_type: 'favorite',
            },
          });
          e.stopPropagation();
        }}
      >
        <Favorite
          manager={favoritesManager}
          data={favoriteData}
          type={favoriteType}
          theme={favoriteTheme}
          iconType={FAVORITE_PLUS_CIRCLE}
        />
      </div>
    );
  }

  renderItems() {
    const { account, openRow, rowIdx, breakpointIsMobile, selectedVideoData } = this.props;
    const { openItemId } = this.state;
    const blocks = this.addDummyBlocks();
    if (!blocks) return null;
    return blocks.map((block, idx) => {
      const { id, width, title, subtitle, badge, starts, ends, isDummy } = block;
      const badgeElement = badge && !isDummy ? <Badge badge={badge} theme={Style} /> : null;

      let itemClass =
        selectedVideoData && selectedVideoData['@id'] === id
          ? classNames(Style.scheduleItem, Style.current)
          : Style.scheduleItem;
      const isOpen = openItemId === id && openRow === rowIdx;
      itemClass = isOpen ? classNames(itemClass, Style.scheduleItemActive) : itemClass;
      itemClass = isDummy ? classNames(itemClass, Style.dummy) : itemClass;

      const hoverTitle = isDummy ? null : `${title}\n(${starts} - ${ends})`;
      const styleWidth = breakpointIsMobile ? null : { width: `${width}px` };

      const arrow = (
        <Icon color="white" icon={isOpen ? 'keyboard-arrow-up' : 'keyboard-arrow-down'} />
      );
      let detailsElement = (
        <span className={Style.titleContainer}>
          <span className={Style.title}>
            {badgeElement}
            <span className={Style.titleText}>{title}</span>
          </span>
          <span className={Style.subtitle}>{subtitle}</span>
        </span>
      );
      if (breakpointIsMobile && isOpen) {
        detailsElement = this.renderDetails();
      }

      return (
        <div
          key={idx}
          className={itemClass}
          style={styleWidth}
          data-test="scheduleitem-item"
          title={hoverTitle}
          onClick={
            isDummy
              ? null
              : () => {
                  if (!isOpen) {
                    handleTealiumButtonAction({
                      text: 'live tv detail',
                      title,
                      subtitle,
                      account,
                    });
                  }
                  this.toggleItemId(id);
                }
          }
        >
          {breakpointIsMobile ? <span className={Style.timestamp}>{starts}</span> : null}
          {detailsElement}
          {breakpointIsMobile ? <span className={Style.caret}>{arrow}</span> : null}
        </div>
      );
    });
  }

  renderOverflowDropdown(ctaDetails) {
    const { overlay } = this.props;
    if (ctaDetails.length < 3) return null;
    const isOpen = overlay === OVERLAY_LIVE_CTA_OVERFLOW;
    const overflowHoverEffect = isOpen ? null : dropdownTheme.overflowHoverEffect;
    const items = ctaDetails.slice(2);

    return (
      <div
        className={Style.overflowButtonWrapper}
        onClick={() => {
          this.toggleOverflowDropdown();
        }}
      >
        <Dropdown
          theme={dropdownTheme}
          items={items}
          onOpenDropdown={this.toggleOverflowDropdown}
          onCloseDropdown={this.toggleOverflowDropdown}
          displayResults
          showMobileCancel
          expanded={isOpen}
          className={classNames(
            Style.dropdown,
            dropdownTheme.overflowDropdown,
            overflowHoverEffect,
          )}
          getIcon={() => {}}
          defaultText="• • •"
        />
      </div>
    );
  }

  render() {
    const { breakpointIsMobile } = this.props;
    return (
      <div className={Style.scheduleMain}>
        <div className={Style.container}>{this.renderItems()}</div>
        {!breakpointIsMobile ? this.renderDetails() : null}
      </div>
    );
  }
}

ScheduleItem.defaultProps = {
  account: {},
  openRow: 0,
  displayPrimeTimeMessage: () => {},
  isAuthenticated: false,
  loadingGrid: false,
  primeTimeMessage: null,
  resetStillWatchingTimeout: () => {},
  selectedDate: {},
  switchChannelCB: () => {},
  breakpointIsMobile: false,
  selectedVideoData: null,
  overlay: null,
  favoritesManager: null,
  location: {},
  prevOpenRow: null,
  prevRowIdx: null,
  restoreLiveGridState: () => {},
  router: {},
};

ScheduleItem.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  breakpointIsMobile: PropTypes.bool,
  callSign: PropTypes.string.isRequired,
  displayPrimeTimeMessage: PropTypes.func,
  dropdownDateClosed: PropTypes.bool,
  epgGridPage: PropTypes.number,
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})),
    setFavorites: PropTypes.func,
    deleteFavorites: PropTypes.func,
  }),
  isAuthenticated: PropTypes.bool,
  item: PropTypes.shape({
    autoPlayStill: PropTypes.shape({}),
    autoPlayVideo: PropTypes.shape({}),
    cacheSetting: PropTypes.string,
    callSign: PropTypes.string,
    dateModified: PropTypes.string,
    headline: PropTypes.string,
    hideIfLoggedIn: PropTypes.bool,
    hideIfNotLoggedIn: PropTypes.bool,
    id: PropTypes.string,
    imageTypes: PropTypes.arrayOf(PropTypes.string),
    images: PropTypes.shape({}),
    items: PropTypes.shape({}),
    itemsPerPage: PropTypes.number,
    name: PropTypes.string,
    panelType: PropTypes.string,
    validFor: PropTypes.number,
  }).isRequired,
  isOverFlow: PropTypes.bool.isRequired,
  lateProgramIdx: PropTypes.number.isRequired,
  loadingGrid: PropTypes.bool,
  location: PropTypes.shape({}),
  network: PropTypes.string.isRequired,
  openRow: PropTypes.number,
  overFlowProgramIdx: PropTypes.number.isRequired,
  overlay: PropTypes.string,
  primeTimeMessage: PropTypes.string,
  prevOpenRow: PropTypes.string,
  prevRowIdx: PropTypes.number,
  restoreLiveGridState: PropTypes.func,
  resetStillWatchingTimeout: PropTypes.func,
  rowIdx: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
  saveLiveRestart: PropTypes.func.isRequired,
  scheduleItemDetailsCB: PropTypes.func.isRequired,
  selectedDate: PropTypes.shape({}),
  selectedVideoData: PropTypes.shape({}),
  setOverlay: PropTypes.func.isRequired,
  startingTs: PropTypes.number.isRequired,
  switchChannelCB: PropTypes.func,
};

const mapStateToProps = state => ({
  favorites: state.app.favorites,
  prevOpenRow: state.live.prevOpenRow,
  prevRowIdx: state.live.prevRowIdx,
});

const mapDispatchToProps = { restoreLiveGridState };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleItem));
